import './index.scss';

(function($) {

  const $titleCard = $('.q-cards-guides-landing-header-title');

  $titleCard.text((index, currentText) => {
    if (currentText.length > 90) return currentText.substr(0, 90).concat('...');
  });

})(jQuery);
